<payee-popup title="Bizonyíték feltöltése">
  <div class="flex vcenter file-row">
    <span class="file-index">1.</span>
    <span class="file-name">{{ data.fileForm.value.file_name }}</span>
  </div>

  <form [formGroup]="data.fileForm">
    <payee-form-field
      width="max"
      [class.condominium-field]="caseTypeControl.value === CASE_TYPE.CONDOMINIUM"
    >
      <span payee-label>
        @if (caseTypeControl.value === CASE_TYPE.INVOICE) {
          Számla kelte
        }
        @if (caseTypeControl.value === CASE_TYPE.CONTRACT) {
          Szerződés kelte
        }
        @if (caseTypeControl.value === CASE_TYPE.CONDOMINIUM) {
          <div class="flex vcenter condominium">
            <div class="condominium-example">
              <img
                src="assets/edit-case-dialog/condominium_date_example.png"
                alt=""
              />
              <span>
                Az egyenlegközlőn általában nem szerepel az első hónap amikor már biztosan tartozott az adós, így azt az alábbiak szerint ki
                kell számolni. Az egyenlegkimutatás első sorában látható az akkori nyitó összeg (a példában 2023. januárhoz -104.175 Ft és
                láthatóan az előírás 13.860 Ft). Az előírások a havi közös költségeket jelentik. Ha 13.860 Ft a havi előírás és 104.175 Ft
                volt a tartozás 2023. januárjában akkor el kell osztanunk a 104175-t 13860-al, hogy megkapjuk, hogy melyik hónapban
                tartozott már az adós. A példa szerint 104175/13860=7,516. Így hét és fél hónapot kellene visszaszámolni 2023. januártól, de
                hogy biztosak legyünk benne, hogy már tartozott az adós, ezért kerekíteni kell, és 7 hónapot számolunk vissza. A példa
                szerint így az első tartozásos hónap 2022. június. Ennek a hónapnak az első napját kell megadni, tehát 2022.06.01. kell
                legyen a megadott dátum.
              </span>
            </div>
            <payee-icon name="info-grey-outline"></payee-icon>
            <span>Tartozás kezdete (az első tartozásos hónap első napja)</span>
          </div>
        }
      </span>
      <payee-datepicker
        formControlName="invoice_date"
        [max]="max"
      ></payee-datepicker>
    </payee-form-field>

    <payee-form-field
      width="max"
      [class.condominium-field]="caseTypeControl.value === CASE_TYPE.CONDOMINIUM"
    >
      <input
        payee-input
        formControlName="invoice_number"
      />
      <span payee-label>
        @if (caseTypeControl.value === CASE_TYPE.INVOICE) {
          Számla sorszáma
        }
        @if (caseTypeControl.value === CASE_TYPE.CONTRACT) {
          A követelés beazonosításához szükséges adatok
        }
        @if (caseTypeControl.value === CASE_TYPE.CONDOMINIUM) {
          <div class="flex vcenter condominium">
            <div class="condominium-example">
              <img
                src="assets/edit-case-dialog/condominium_address_example.png"
                alt=""
              />
              <span>
                Az albetét teljes címe a "H-" rész nélkül. Például ebben az esetben: 1225 Budapest, Tenkes u. 6 A / földszint / 3. (lakás)
              </span>
            </div>
            <payee-icon name="info-grey-outline"></payee-icon>
            <span>Ingatlan címe</span>
          </div>
        }
      </span>
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      mat-dialog-close
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
